<template>
  <div class="order">
    <Search @searchOrder="searchOrder" :CommodityArr="CommodityArr" />
    <div class="orderContent">
      <!-- 订单列表 -->
      <div v-if="orderNoListFlag">
        <div
          class="orderHeader"
          :class="navBarFixed == true ? 'navBarWrap' : ''"
        >
          <div class="goods">商品</div>
          <div class="orderSpecifications">规格</div>
          <div class="ordrerNumber">下单件数</div>
          <div class="ordrerNumber">实际数量</div>
          <div class="goodsRemark">商品备注</div>
          <div class="orderAmount">合计</div>
          <div class="orderType">订单状态</div>
          <div class="orderReamrk">订单备注</div>
        </div>
        <div v-for="(item, index) in orderList" :key="index" class="subject">
          <PlainGold
            @showHidden="showHidden"
            :pieceData="item"
            :index="index"
          />
        </div>
        <!-- 分页组件 -->
        <div class="box_fenye" v-if="total">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="listQuery.current"
            :page-sizes="[10, 20, 40, 60, 100]"
            :page-size="listQuery.size"
            layout="total, prev, pager, next, sizes, jumper"
            :total="total"
            background
          >
          </el-pagination>
        </div>
      </div>
      <div v-if="+total === 0" style="margin: 159px 0;text-align: center;">
        <img src="@/assets/img/noData.png" alt="" />
      </div>
    </div>
  </div>
</template>

<script>
import Search from './components/Search.vue'
import PlainGold from './components/PlainGold.vue'
import { getList, getState } from '@/api/orderApi'
export default {
  name: 'Order',
  components: {
    Search,
    PlainGold,
  },
  data() {
    return {
      orderNoListFlag: true,
      navBarFixed: false,
      CommodityArr: [
        {
          title: '全部',
          status: '',
          badge: '',
        },
        {
          title: '待支付',
          status: '10',
          badge: '',
        },
        {
          title: '已支付',
          status: '20',
          badge: '',
        },
        {
          title: '已送检',
          status: '40',
          badge: '',
        },
        {
          title: '已入网',
          status: '90',
          badge: '',
        },
        {
          title: '已发货',
          status: '50',
          badge: '',
        },
        {
          title: '已完成',
          status: '80',
          badge: '',
        },
        // {
        //   title: '已作废',
        //   status: '60',
        //   badge: '',
        // },
        {
          title: '已取消',
          status: '70',
          badge: '',
        },
      ],
      listQuery: {
        size: 10,
        current: 1,
        styleNumber: '',
        orderNo: '',
        netAddress: '',
        netCode: '',
        orderStatus: '',
      },
      orderList: [],
      badge: {},
      total: 0,
    }
  },
  mounted() {
    // 订单列表
    this.getOrderList()
    // 订单未读数量查询
    this.getCustomerCode()
    // 事件监听滚动条
    window.addEventListener('scroll', this.watchScroll)
  },
  methods: {
    watchScroll() {
      var scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop
      //  当滚动超过 50 时，实现吸顶效果
      if (scrollTop > 289) {
        this.navBarFixed = true
      } else {
        this.navBarFixed = false
      }
    },
    searchOrder(searchCondition, status) {
      this.listQuery.current = 1
      this.listQuery = { ...this.listQuery, ...searchCondition }
      this.listQuery.orderStatus = status
      this.getOrderList(status)
    },
    // 获取角标数量
    getCustomerCode() {
      const type = 'get'
      getState(type).then((res) => {
        // 未读角标
        this.badge = res.data
        this.$nextTick(() => {
          let isEmpty = (obj) => (JSON.stringify(obj) === '{}' ? true : false)
          this.CommodityArr.forEach((ele) => {
            if (isEmpty(this.badge)) {
              ele.badge = ''
            } else {
              for (var i in this.badge) {
                if ((i = ele.status)) {
                  ele.badge = this.badge[i]
                } else {
                  ele.badge = ''
                }
              }
            }
          })
        })
      })
    },
    // 获取已读角标
    getUnread() {
      let obj = {
        ids: [],
      }
      const type = 'PUT'
      this.orderList.forEach((item) => {
        obj.ids.push(item.id)
      })
      getState(obj.ids, type).then((res) => {
        this.getCustomerCode()
      })
    },
    getOrderList(status) {
      getList(this.listQuery).then((res) => {
        if (res.code === 0) {
          this.orderList = []
          res.data.records.forEach((item) => {
            if (item.detailList.length > 1) {
              item.showNone = true
            } else {
              item.showNone = false
            }
            this.orderList.push(item)
          })
          if (res.data.total > 0) {
            this.orderNoListFlag = true
          } else {
            this.orderNoListFlag = false
          }
          this.total = res.data.total
          // 点击标题改变角标数量
          if (status) {
            this.getUnread()
          }
        }
      })
    },
    showHidden(index) {
      this.orderList[index].showNone = !this.orderList[index].showNone
    },
    // 分页组件切换页数
    handleSizeChange(val) {
      this.listQuery.size = val
      this.getOrderList()
    },
    // 外层分页组件切换
    handleCurrentChange(val) {
      this.listQuery.current = val
      this.getOrderList()
    },
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.watchScroll)
  },
}
</script>

<style scoped lang="scss">
.box_fenye {
  display: flex;
  justify-content: center;
  padding-bottom: 10px;
}

.order {
  .orderContent {
    max-width: 1500px;
    margin: 0 auto;
    min-height: 700px;

    .subject {
      margin-bottom: 12px;
      overflow-x: auto;
      -webkit-overflow-scrolling: touch;
      white-space: nowrap;
    }
  }
}

.orderHeader {
  display: flex;
  align-items: center;
  height: 50px;
  background: rgba(242, 242, 242, 1);
  padding-left: 6px;
}

.navBarWrap {
  position: fixed;
  top: 0;
  z-index: 999;
  width: 1494px;
}

.goods {
  display: flex;
  width: 230px;
}

.orderSpecifications {
  width: 200px;
  padding-right: 30px;
}

.orderLabel {
  width: 90px;
}

.ordrerNumber {
  width: 80px;
}

.orderReamrk {
  width: 140px;
}

.goodsRemark {
  width: 150px;
}

.orderAmount {
  width: 240px;
  margin-left: 20px;
}

.orderType {
  width: 80px;
}

.right {
  border-right: none;
}
</style>
<style>
.demo-tabletable-expand {
  font-size: 0;
}

.demo-table-expand label {
  width: 90px;
  color: #99a9bf;
}

.demo-table-expand .el-form-item {
  margin-right: 0;
  margin-bottom: 0;
  width: 50%;
}

.el-scrollbar__view .selected {
  color: #cdcdcd;
}

.el-scrollbar__view li {
  color: #ec9368;
}
</style>
